
function Title(props){
	return(
		<div className="pb-5">
			<span className="text-2xl">{props.title}</span>
			<hr className="bg-purple-200 h-0.5"/>
		</div>
	)
}

export default Title;